// src/pages/CountySelectPage.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCounties } from '../lib/db';
import BottomNav from '../components/layout/BottomNav';

const CountySelectPage = () => {
  const navigate = useNavigate();
  const [counties, setCounties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCounties().then(c => { setCounties(c); setLoading(false); });
  }, []);

  // Fallback counties for demo if DB empty
  const display = counties.length > 0 ? counties : [
    { id: 'galway', name: 'Galway', towns: 'Loughrea · Tuam · Ballinasloe', status: 'live' },
    { id: 'clare', name: 'Clare', towns: 'Ennis · Kilrush · Killaloe', status: 'soon' },
    { id: 'mayo', name: 'Mayo', towns: 'Castlebar · Westport · Ballina', status: 'soon' },
    { id: 'roscommon', name: 'Roscommon', towns: 'Roscommon · Boyle · Strokestown', status: 'soon' },
    { id: 'tipperary', name: 'Tipperary', towns: 'Thurles · Clonmel · Nenagh', status: 'soon' },
  ];

  return (
    <div className="page" style={{ background: 'var(--cream)' }}>
      <div style={{ padding: '52px 20px 16px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: 'var(--ink)', marginBottom: 4, letterSpacing: '-0.3px' }}>
          Choose your county
        </h1>
        <p style={{ fontSize: 14, color: 'var(--muted)', fontWeight: 500 }}>
          We'll show you the towns where Gather is live
        </p>
      </div>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><div className="spinner" /></div>
      ) : (
        <div style={{ padding: '4px 18px', display: 'flex', flexDirection: 'column', gap: 10 }}>
          {display.map(county => (
            <div
              key={county.id}
              style={cardStyle}
              onClick={() => county.status === 'live'
                ? navigate(`/county/${county.id}/towns`)
                : alert(`${county.name} is coming soon to Gather!`)
              }
            >
              <span style={{ fontSize: 28 }}>{county.status === 'live' ? '🟢' : '⚪'}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--ink)', marginBottom: 2 }}>{county.name}</div>
                <div style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 500 }}>{county.towns}</div>
              </div>
              <span className={`chip ${county.status === 'live' ? 'chip-live' : 'chip-soon'}`}>
                {county.status === 'live' ? '● Live' : 'Coming soon'}
              </span>
              <span style={{ color: 'var(--border)', fontSize: 20 }}>›</span>
            </div>
          ))}
        </div>
      )}
      <BottomNav />
    </div>
  );
};

const cardStyle = {
  background: 'var(--white)', borderRadius: 18, padding: '16px 18px',
  display: 'flex', alignItems: 'center', gap: 14, cursor: 'pointer',
  boxShadow: 'var(--shadow-sm)',
};

export default CountySelectPage;
